module.exports = __webpack_public_path__ + "static/media/section_10_img.a24d3c75.svg";